import environments from "../../../../environments";
import { AraucariaEstacionamento } from "./providers/araucaria";
import { CarambeiEstacionamento } from "./providers/carambei";
import { JacarezinhoEstacionamento } from "./providers/jcz";
import { PalmeiraEstacionamento } from "./providers/palmeira";
import { StandardEstacionamento } from "./providers/standard";
import { WbEstacionamento } from "./providers/wb";

export const ParkingLot: React.FC = () => {
    switch (environments.client.name) {
        case "carambei":
            return <CarambeiEstacionamento />;
        case "jcz":
            return <JacarezinhoEstacionamento />;
        case "palmeira":
            return <PalmeiraEstacionamento />;
        case "araucaria":
            return <AraucariaEstacionamento />;
        case "wb":
            return <WbEstacionamento />;
        default:
            return <StandardEstacionamento />;
    }
};
